<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建共建</el-breadcrumb-item>
				<el-breadcrumb-item>业务发展</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.query.type=='add'?'新增':'编辑'}}业务发展</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary" size="small"
						@click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="addTitle">{{$route.query.type=='add'?'新增':'编辑'}}业务发展</div>
					<div class="addWrap">
						<el-form 
							label-position="right"
							label-width="70px"
							ref="formData" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="标题" prop="title">
								<el-input
									placeholder="请输入标题"
									v-model="formData.title">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item" label="封面" prop="">
								<el-upload
									:data="{token:$store.state.user.userinfo.token}"
									style="text-align: left !important;"
									name="file"
									:action="$uploadImg"
									:show-file-list="false"
									:on-success="success"
									:before-upload="$limitImg">
									<img v-if="imageUrl" :src="imageUrl" class="fengmian">
									<el-button  type="primary">{{imageUrl == null || imageUrl == ''?'上传封面':'重新上传'}}</el-button>
									<div class="tishi">支持格式：jpg、png，图片不得大于2M&nbsp;&nbsp;&nbsp;版本更新如图片丢失请重新上传提交</div>
								</el-upload>
							</el-form-item>
							<el-form-item class="form_item" label="发布时间">
							  <el-date-picker
								  v-model="formData.pub_time"
								  type="date"
								  format="yyyy-MM-dd"
								  value-format="timestamp"
								  placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
							<el-form-item class="form_item" label="来源" prop="">
								<el-input
									placeholder="请输入来源"
									v-model="formData.source">
								</el-input>
							</el-form-item>
							<el-form-item 
								style="align-items: center !important;"
								class="form_item" label="类型" prop="">
								<el-radio-group v-model="type" @change="changeType">
									<el-radio label="图文"></el-radio>
									<el-radio label="链接"></el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item v-if="type == '图文'" class="form_item fuwenben" label="内容"  prop="content">
								<quill-editor :options="$VueQuillEditor" ref="myTextEditor" v-model="formData.content" style="height:327px !important;width: 800px;"></quill-editor>
							</el-form-item>
							<el-form-item v-if="type == '链接'" class="form_item fuwenben" label="链接"  prop="url">
								 <el-input style="width: 500px !important;" placeholder="请输入链接" v-model="formData.url"></el-input>
							</el-form-item>
							<el-form-item class="form_item submit">
								<el-button type="primary" @click="submit()">发布</el-button>
								<el-button @click="$router.go(-1)">取消</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Add from './mixins/add.js';
	export default {
		mixins:[Add]
	}
</script>

<style lang="scss">
	.wrap{
		width: 100%;
		position: relative;
		color: $index_color;
		font-size: index_size1;
		.addTitle{
			width: 100%;
			border-bottom: 1px solid #DDE2EE;
			padding-bottom: 15px;
			margin: -40px 0 20px 0;
			font-size: 18px;
			color: #333333;
			font-weight: bold;
			width: 80%;
		}
		.addWrap{
			.el-upload{
				text-align: left !important;
			}
			.form_item{
				width: 100%;
				margin-bottom: 15px;
				display: flex !important;
				align-items: flex-start !important;
				font-size: 14px;
				.el-input{
					width: 220px !important;
				}
				.fengmian{
					display: inline-block;
					vertical-align: bottom;
					height: 150px;
					margin-right: 10px;
					margin-left: 0;
					width: 223px;
				}
				.picture{
					display: inline-block;
					vertical-align: bottom;
					margin-right: 10px;
					margin-left: 0;
					width: 110px;
					height: 150px;
				}
				.tishi{
					font-size: 12px;
					color: rgb(131, 138, 157);
					margin-top: 10px;
				}
			}
			.el-form-item__content{
				margin-left: 0 !important;
			}
			.fuwenben{
				padding-bottom: 110px;
			}
			.submit{
				padding-left: 85px;
			}
			.el-form-item__error{
				position: relative !important;
				margin-left: 20px;
				line-height: 30px;
			}
		}
	}
</style>
